import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography, Paper, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axios from 'axios';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';

const SignupPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const navigate = useNavigate();

    const handleSignup = async () => {
        setLoading(true);
        setError(null);

        try {
            // Create user in Firebase Authentication
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            console.log("User registered: ", userCredential);

            // Retrieve the Firebase UID
            const firebaseUID = userCredential.user.uid;

            // Send user data to the backend API
            const response = await axios.post(
                'https://europe-west1-seismic-relic-390308.cloudfunctions.net/TenantTest',
                { email, password, firebaseUID },
                { headers: { 'Content-Type': 'application/json' } }
            );
           
            const { tenantID } = response.data.user;
          
            // Store tenantID for future use (e.g., in state, context, or localStorage)
            console.log('User registered successfully, Tenant ID:', tenantID);

            // Redirect to login page on success
            navigate('/login');
        } catch (err: any) {
            console.error('Signup error:', err);
            setError(err.response?.data?.error || 'Failed to sign up.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                backgroundColor: '#f4f6f8',
                padding: 2,
                position: 'relative',
            }}
        >
            <IconButton
                onClick={() => navigate('/login')}
                sx={{
                    position: 'absolute',
                    top: 20,
                    left: 20,
                    color: '#007BFF',
                }}
            >
                <ArrowBackIcon />
            </IconButton>

            <Paper
                elevation={3}
                sx={{
                    width: '100%',
                    maxWidth: 400,
                    padding: 3,
                    textAlign: 'center',
                    backgroundColor: '#fff',
                    borderRadius: 2,
                }}
            >
                <Typography variant="h5" sx={{ marginBottom: 2 }}>
                    Sign Up
                </Typography>
                {error && (
                    <Typography sx={{ color: 'red', marginBottom: 2 }}>
                        {error}
                    </Typography>
                )}

                <TextField
                    label="Email"
                    type="email"
                    variant="outlined"
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{ marginBottom: 2 }}
                />
                <TextField
                    label="Password"
                    type="password"
                    variant="outlined"
                    fullWidth
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    sx={{ marginBottom: 3 }}
                />
                <Button
                    variant="contained"
                    fullWidth
                    onClick={handleSignup}
                    disabled={loading}
                    sx={{
                        padding: 1.2,
                        backgroundColor: '#007BFF',
                        ':hover': {
                            backgroundColor: '#0056b3',
                        },
                    }}
                >
                    {loading ? 'Signing Up...' : 'Sign Up'}
                </Button>
            </Paper>
        </Box>
    );
};
 

export default SignupPage;